/********************************************************************************
 * Copyright (c) 2023-2024 EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/
import { BrowserMessageReader, BrowserMessageWriter, MessageConnection, createMessageConnection } from 'vscode-jsonrpc/browser';
import { GLSPConnectionHandler } from './ws-connection-provider';

export class GLSPWebWorkerProvider {
    protected worker: Worker;

    constructor(protected url: string) {}

    protected createWebWorker(url: string): Worker {
        return new Worker(url);
    }

    listen(handler: GLSPConnectionHandler): MessageConnection {
        this.worker = this.createWebWorker(this.url);
        const wwConnection = createMessageConnection(new BrowserMessageReader(this.worker), new BrowserMessageWriter(this.worker));

        handler.logger?.warn('GLSPWebWorkerProvider Initializing!');
        handler.onConnection?.(wwConnection);

        return wwConnection;
    }
}
